<template>
  <div class="container rtl max-w-screen-md mb-5 px-0">
    <RatioImage v-if="promotion?.banner_media" ratio="2:1" :src="imgProxy(promotion.banner_media?.url)"
      :tip="dt(promotion.title_translations)" />
    <div class="text-center text-2xl my-3">活動內容</div>
    <div class="text-center font-bold mb-3">
      <el-tag type="danger" effect="dark">{{ promotionTypeLabel }}</el-tag>
      {{ dt(promotion?.title_translations) }}
      <small v-if="promotion?.min_amount_free_shipping">
        (滿 {{ $n(promotion?.min_amount_free_shipping) }} 免運)
      </small>
    </div>

    <!-- 商品區 -->
    <ProductLists :products="storeProducts" :store-data="storeData" />
    <div class="linear-line"></div>

    <!-- 加購品區 -->
    <div id="block-additionals">
      <a class="block text-center text-3xl font-semibold my-4">
        🌟加購品🌟
      </a>
      <!-- 加購商品 -->
      <AddonProductListVertical fields="assorts,assorts.image_url" search_from="carts" search_title="購物車"
        search_path="購物車>加購商品" :black-list="cartData.carts" :store-data="storeData"
        :currency-symbol="cartData.currency_symbol" :limit="5" hide-header hide-pagination @refresh:carts="updateCart" />
      <div class="linear-line"></div>
    </div>

    <!-- 購物車區 -->
    <div>
      <div class="flex justify-content-between" :class="isMobile ? ['flex-col'] : ['align-items-end']">
        <a class="block text-center text-2xl font-semibold mt-4 mb-2">
          目前已經選購 ({{ $n(store.getters['lite/cartCount']) }}) 件商品
        </a>

        <a v-if="!loginUserId" href="/login">
          <div
            class="login-hint mx-1 px-3 items-center text-white leading-none lg:rounded-full flex lg:inline-flex lg:px-5"
            role="alert">
            <!-- <span class="flex rounded-full bg-indigo-500 uppercase px-2 py-1 text-xs font-bold mr-3">New</span> -->
            <span class="font-semibold mr-2 text-left flex-auto">
              登入/註冊會員，可方便您管理訂單。
            </span>
            <svg class="fill-current opacity-75 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z" />
            </svg>
          </div>
        </a>
      </div>

      <ProductCarts />
      <div class="linear-line"></div>
    </div>

    <PromotionProductChooseAssortDialog :promotion="promotion" :store-data="props.storeData" />
    <CheckoutFormDialog />
    <CheckoutLoginDialog />
    <ProductFabs />
  </div>
</template>

<script setup>
import { reactive, ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from "vue-i18n"
import { cloneDeep } from "lodash"
import AddonProductListVertical from "../products/AddonProductListVertical.vue"
import parsePhoneNumber from "libphonenumber-js"
import {
  dataTranslations as dt,
  notificationErrors,
  currencyFormat,
  checkValidCurrencyStr,
  dateFormat,
  assignCartCount,
  breakpoint,
  imgProxy,
  lookupPromotionTypes,
  convertPriceCurrencies,
} from "../../utils"
import RatioImage from '../RatioImage.vue'
import ProductLists from "./ProductLists.vue"
import ProductCarts from "./ProductCarts.vue"
import PromotionProductChooseAssortDialog from "./PromotionProductChooseAssortDialog.vue"
import CheckoutFormDialog from "./CheckoutFormDialog.vue"
import CheckoutLoginDialog from "./CheckoutLoginDialog.vue"
import ProductFabs from "./ProductFabs.vue"

const props = defineProps({
  page: Object,
  storeData: Object,
  userData: Object,
})
const { t, locale } = useI18n()

const store = useStore()
const isMobile = computed(() => breakpoint.value.xs || breakpoint.value.sm)
const promotion = computed(() => props.page?.data?.store_promotion)
const currency = computed(() => props.storeData?.currency || 'TWD')
const cartData = computed(() => store.getters['lite/cartData'])
const loginUserId = computed(() => store.getters['lite/userData']?.id)
const promotionTypeLabel = computed(() => {
  const list = lookupPromotionTypes()
  const item = list.find((el) => el.value === promotion.value?.type)
  if (item) {
    return item.label
  }
  return promotion.value?.type
})
const storeProducts = computed(() => {
  const list = []
  promotion.value?.whitelisted_store_products.forEach((pdt) => {
    // console.debug("storeProducts", pdt)
    list.push({
      ...pdt,
      price_range: convertPriceCurrencies(pdt.price_range, currency.value),
    })
  })
  // promotion?.whitelisted_store_products
  // convertPriceCurrencies(item.price_range, currency)
  return list
})
const updateCart = () => {
  store.dispatch('lite/updateCart');
}

onMounted(() => {
  store.commit('lite/setStoreData', props.storeData);
  store.commit('lite/setDealerData', props.dealerData);
  store.commit('lite/setIsSubscribe', props.isSubscribe);
  // 特殊處理 user.mobile E164 to local number
  const userData = cloneDeep(props.userData);
  // if (userData?.mobile && userData?.mobile?.startsWith("+")) {
  //   const phoneNumber = parsePhoneNumber(userData.mobile);
  //   if (['TW', 'MY'].includes(phoneNumber.country)) {
  //     userData.mobile = `0${phoneNumber.nationalNumber}`
  //   } else {
  //     userData.mobile = `${phoneNumber.nationalNumber}`
  //   }
  // }
  store.commit('lite/setUserData', userData);
  updateCart();
})
</script>

<style scoped="scss">
.login-hint {
  background-color: var(--primary_color);
  height: 3rem;
}
</style>
